module.exports = __webpack_public_path__ + "img/usdc.c76b33ca.png";